export default {
  // PlantSelect
  api_r_user_module_legalCompliance_plantSelect_loadModule: {
    path: 'm/legal-compliance/plant-select/load-module/',
  },
  api_r_user_module_legalCompliance_plantSelect_autoClone_clone: {
    path: 'm/legal-compliance/plant-select/auto-clone/clone/',
  },
  api_r_user_module_legalCompliance_plantSelect_autoClone_delete: {
    path: 'm/legal-compliance/plant-select/auto-clone/delete/',
  },
  api_r_user_module_legalCompliance_plantSelect_autoClone_selectLocations: {
    path: 'm/legal-compliance/plant-select/auto-clone/select-locations/',
  },
  api_r_user_module_legalCompliance_plantSelect_resetPlantState: {
    path: 'm/legal-compliance/plant-select/reset-plant-state/',
  },
  api_r_user_module_legalCompliance_plantSelect_downloadWelcomeCustomFile: {
    path: 'm/legal-compliance/plant-select/download-welcome-custom-file/',
  },
  // Evaluation
  api_r_user_module_legalCompliance_evaluation_loadLayout: {
    path: 'm/legal-compliance/evaluation/load-layout/',
  },
  api_r_user_module_legalCompliance_evaluation_getPermissions: {
    path: 'm/legal-compliance/evaluation/get-permissions/',
  },
  api_r_user_module_legalCompliance_evaluation_loadPlantObligations: {
    path: 'm/legal-compliance/evaluation/load-plantObligations/',
  },
  api_r_user_module_legalCompliance_evaluation_copyObligations: {
    path: 'm/legal-compliance/evaluation/copy-obligations/',
  },
  api_r_user_module_legalCompliance_evaluation_generateFilterHexCode: {
    path: 'm/legal-compliance/evaluation/generate-filter-hex-code/',
  },
  api_r_user_module_legalCompliance_evaluation_getFilters: {
    path: 'm/legal-compliance/evaluation/get-filters/',
  },
  api_r_user_module_legalCompliance_evaluation_loadPoLevel: {
    path: 'm/legal-compliance/evaluation/load-poLevel/',
  },
  api_r_user_module_legalCompliance_evaluation_changeState: {
    path: 'm/legal-compliance/evaluation/change-state/',
  },
  api_r_user_module_legalCompliance_evaluation_changeSecondState: {
    path: 'm/legal-compliance/evaluation/change-second-state/',
  },
  api_r_user_module_legalCompliance_evaluation_changeGoalState: {
    path: 'm/legal-compliance/evaluation/change-goal-state/',
  },
  api_r_user_module_legalCompliance_evaluation_changeProbSev: {
    path: 'm/legal-compliance/evaluation/change-prob-sev/',
  },
  api_r_user_module_legalCompliance_evaluation_changeLastVerification: {
    path: 'm/legal-compliance/evaluation/change-last-verification/',
  },
  api_r_user_module_legalCompliance_evaluation_getStateHistory: {
    path: 'm/legal-compliance/evaluation/get-state-history/',
  },
  api_r_user_module_legalCompliance_evaluation_editStateHistory: {
    path: 'm/legal-compliance/evaluation/edit-state-history/',
  },
  api_r_user_module_legalCompliance_evaluation_setFavouriteObligation: {
    path: 'm/legal-compliance/evaluation/set-favourite-obligation/',
  },
  api_r_user_module_legalCompliance_evaluation_plantObligationTag_toggle: {
    path: 'm/legal-compliance/evaluation/toggle-plantobligation-tag/',
  },
  api_r_user_module_legalCompliance_evaluation_obligationAssociation_toggle: {
    path: 'm/legal-compliance/evaluation/toggle-obligationAssociation/',
  },
  api_r_user_module_legalCompliance_evaluation_setMaintenanceChecked: {
    path: 'm/legal-compliance/evaluation/set-maintenance-check/',
  },
  api_r_user_module_legalCompliance_evaluation_setUserMarkObligation: {
    path: 'm/legal-compliance/evaluation/set-user-mark-obligation/',
  },
  api_r_user_module_legalCompliance_evaluation_tab_information: {
    path: 'm/legal-compliance/evaluation/tabs/information/',
  },
  api_r_user_module_legalCompliance_evaluation_tab_legal: {
    path: 'm/legal-compliance/evaluation/tabs/legal/',
  },
  api_r_user_module_legalCompliance_evaluation_tab_legal_downloadLawFile: {
    path: 'm/legal-compliance/evaluation/tabs/legal/download-law-file/',
  },
  api_r_user_module_legalCompliance_evaluation_getNavbarInfo: {
    path: 'm/legal-compliance/evaluation/get-navbar-info/',
  },
  api_r_user_module_legalCompliance_evaluation_getPlantManagers: {
    path: 'm/legal-compliance/evaluation/get-plant-managers/',
  },
  api_r_user_module_legalCompliance_evaluation_setPlantManagers: {
    path: 'm/legal-compliance/evaluation/set-plant-managers/',
  },
  api_r_user_module_legalCompliance_evaluation_getCategories: {
    path: 'm/legal-compliance/evaluation/get-categories/',
  },
  api_r_user_module_legalCompliance_evaluation_getLayout: {
    path: 'm/legal-compliance/evaluation/get-layout/',
  },
  api_r_user_module_legalCompliance_evaluation_getCategoryGroups: {
    path: 'm/legal-compliance/evaluation/get-category-groups/',
  },
  api_r_user_module_legalCompliance_evaluation_getNotes: {
    path: 'm/legal-compliance/evaluation/get-notes/',
  },
  api_r_user_module_legalCompliance_evaluation_getObligationAssociations: {
    path: 'm/legal-compliance/evaluation/get-obligation-associations/',
  },
  api_r_user_module_legalCompliance_evaluation_getObligationGroups: {
    path: 'm/legal-compliance/evaluation/get-obligation-groups/',
  },
  api_r_user_module_legalCompliance_evaluation_plantRequest: {
    path: 'm/legal-compliance/evaluation/plant-request/',
  },
  api_r_user_module_legalCompliance_evaluation_userQuery_add: {
    path: 'm/legal-compliance/evaluation/user-query/add/',
  },
  api_r_user_module_legalCompliance_evaluation_userQuery_list: {
    path: 'm/legal-compliance/evaluation/user-query/list/',
  },
  api_r_user_module_legalCompliance_evaluation_userQuery_messages: {
    path: 'm/legal-compliance/evaluation/user-query/messages/',
  },
  api_r_user_module_legalCompliance_evaluation_userQuery_messages_file_download:
    {
      path: 'm/legal-compliance/evaluation/user-query/messages/file/download/',
    },
  api_r_user_module_legalCompliance_evaluation_userQuery_messages_set: {
    path: 'm/legal-compliance/evaluation/user-query/messages/set/',
  },
  api_r_user_module_legalCompliance_evaluation_userQuery_messages_score_set: {
    path: 'm/legal-compliance/evaluation/user-query/messages/score/set/',
  },
  // Evidences
  api_r_user_module_legalCompliance_evidences_tab: {
    path: 'm/legal-compliance/evidences/tab/',
  },
  api_r_user_module_legalCompliance_evidences_download: {
    path: 'm/legal-compliance/evidences/download/',
  },
  api_r_user_module_legalCompliance_evidences_upload: {
    path: 'm/legal-compliance/evidences/upload/',
  },
  api_r_user_module_legalCompliance_evidences_edit: {
    path: 'm/legal-compliance/evidences/edit/',
  },
  api_r_user_module_legalCompliance_evidences_remove: {
    path: 'm/legal-compliance/evidences/remove/',
  },
  api_r_user_module_legalCompliance_evidences_removedHistory: {
    path: 'm/legal-compliance/evidences/removed-history/',
  },
  api_r_user_module_legalCompliance_evidences_list: {
    path: 'm/legal-compliance/evidences/list/',
  },
  api_r_user_module_legalCompliance_autofilter: {
    path: 'm/legal-compliance/evaluation/auto-filter/',
  },
  // Calendar
  api_r_user_module_legalCompliance_calendar_tab: {
    path: 'm/legal-compliance/calendar/tab/',
  },
  api_r_user_module_legalCompliance_calendar_add: {
    path: 'm/legal-compliance/calendar/add/',
  },
  api_r_user_module_legalCompliance_calendar_edit: {
    path: 'm/legal-compliance/calendar/edit/',
  },
  api_r_user_module_legalCompliance_calendar_remove: {
    path: 'm/legal-compliance/calendar/remove/',
  },
  api_r_user_module_legalCompliance_calendar_solveEvent: {
    path: 'm/legal-compliance/calendar/solve-event/',
  },
  api_r_user_module_legalCompliance_calendar_changeNextDateSettings: {
    path: 'm/legal-compliance/calendar/change-next-date-settings/',
  },
  api_r_user_module_legalCompliance_calendar_createAttachEvidence: {
    path: 'm/legal-compliance/calendar/create-attach-evidence/',
  },
  // Corrective Actions
  api_r_user_module_legalCompliance_correctiveActions_tab: {
    path: 'm/legal-compliance/corrective-actions/tab/',
  },
  api_r_user_module_legalCompliance_correctiveActions_task_new: {
    path: 'm/legal-compliance/corrective-actions/task/new/',
  },
  api_r_user_module_legalCompliance_correctiveActions_taskUpdate_new: {
    path: 'm/legal-compliance/corrective-actions/task-update/new/',
  },
  api_r_user_module_legalCompliance_correctiveActions_task_edit: {
    path: 'm/legal-compliance/corrective-actions/task/edit/',
  },
  api_r_user_module_legalCompliance_correctiveActions_task_remove: {
    path: 'm/legal-compliance/corrective-actions/task/remove/',
  },
  api_r_user_module_legalCompliance_correctiveActions_taskUpdate_edit: {
    path: 'm/legal-compliance/corrective-actions/task-update/edit/',
  },
  api_r_user_module_legalCompliance_correctiveActions_taskUpdate_edit_calcs: {
    path: 'm/legal-compliance/corrective-actions/task-update/edit-calcs/',
  },
  api_r_user_module_legalCompliance_correctiveActions_taskUpdate_remove: {
    path: 'm/legal-compliance/corrective-actions/task-update/remove/',
  },
  api_r_user_module_legalCompliance_correctiveActions_task_getEditLists: {
    path: 'm/legal-compliance/corrective-actions/task/get-edit-lists/',
  },
  api_r_user_module_legalCompliance_correctiveActions_task_getMultiList: {
    path: 'm/legal-compliance/corrective-actions/task/get-multi-list/',
  },
  api_r_user_module_legalCompliance_correctiveActions_taskUpdate_getEditLists: {
    path: 'm/legal-compliance/corrective-actions/task-update/get-edit-lists/',
  },
  api_r_user_module_legalCompliance_correctiveActions_task_downloadFile: {
    path: 'm/legal-compliance/corrective-actions/task/download-file/',
  },
  api_r_user_module_legalCompliance_correctiveActions_taskUpdate_downloadFile: {
    path: 'm/legal-compliance/corrective-actions/task-update/download-file/',
  },
  api_r_user_module_legalCompliance_correctiveActions_task_changeState: {
    path: 'm/legal-compliance/corrective-actions/task/change-state/',
  },
  api_r_user_module_legalCompliance_correctiveActions_task_supervise: {
    path: 'm/legal-compliance/corrective-actions/task/supervise/',
  },
  api_r_user_module_legalCompliance_correctiveActions_supervision_reset: {
    path: 'm/legal-compliance/corrective-actions/supervision/reset/',
  },
  api_r_user_module_legalCompliance_correctiveActions_taskUpdate_changeState: {
    path: 'm/legal-compliance/corrective-actions/task-update/change-state/',
  },
  // Sanction
  api_r_user_module_legalCompliance_sanction_tab: {
    path: 'm/legal-compliance/sanction/tab/',
  },
  api_r_user_module_legalCompliance_sanction_edit: {
    path: 'm/legal-compliance/sanction/edit/',
  },
  api_r_user_module_legalCompliance_sanction_remove: {
    path: 'm/legal-compliance/sanction/remove/',
  },
  // NoAcceptance
  api_r_user_module_legalCompliance_noAcceptance_tab: {
    path: 'm/legal-compliance/noAcceptance/tab/',
  },
  api_r_user_module_legalCompliance_noAcceptance_edit: {
    path: 'm/legal-compliance/noAcceptance/edit/',
  },
  // CustomObligationTexts
  api_r_user_module_legalCompliance_customObligationTexts_tab: {
    path: 'm/legal-compliance/custom-obligation-texts/tab/',
  },
  api_r_user_module_legalCompliance_customObligationTexts_add: {
    path: 'm/legal-compliance/custom-obligation-texts/add/',
  },
  api_r_user_module_legalCompliance_customObligationTexts_remove: {
    path: 'm/legal-compliance/custom-obligation-texts/remove/',
  },
  // Responsible
  api_r_user_module_legalCompliance_responsible_getResponsibles: {
    path: 'm/legal-compliance/responsible/get-responsibles/',
  },
  api_r_user_module_legalCompliance_responsible_tab: {
    path: 'm/legal-compliance/responsible/tab/',
  },
  api_r_user_module_legalCompliance_responsible_edit: {
    path: 'm/legal-compliance/responsible/edit/',
  },
  // ObligationForm
  api_r_user_m_legalCompliance_getPlantObligationFormData: {
    path: 'm/legal-compliance/obligation-form/get-plant-obligation-form-data/',
  },
  api_r_user_m_legalCompliance_getPlantObligationForm: {
    path: 'm/legal-compliance/obligation-form/get-plant-obligation-form/',
  },
  api_r_user_m_legalCompliance_plantObligationFormFinish: {
    path: 'm/legal-compliance/obligation-form/plant-obligation-form-finish/',
  },
  api_r_user_m_legalCompliance_plantObligationFormDraft: {
    path: 'm/legal-compliance/obligation-form/plant-obligation-form-draft/',
  },
  api_r_user_m_legalCompliance_plantObligationFormResults: {
    path: 'm/legal-compliance/obligation-form/plant-obligation-form-results/',
  },
  api_r_user_m_legalCompliance_plantObligationFormAssign: {
    path: 'm/legal-compliance/obligation-form/plant-obligation-form-assign/',
  },
  api_r_user_m_legalCompliance_plantObligationFormQuestionHelpFileDownload: {
    path: 'm/legal-compliance/obligation-form/plant-obligation-form-question-help-file-download/',
  },
  // Plant ObligationForm
  api_r_user_m_legalCompliance_plantObligationForm_userAnswers_get: {
    path: 'm/legal-compliance/plant-obligation-form/user-answers/get/',
  },
  api_r_user_m_legalCompliance_plantObligationForm_get: {
    path: 'm/legal-compliance/plant-obligation-form/get/',
  },
  api_r_user_m_legalCompliance_plantObligationForm_question_change: {
    path: 'm/legal-compliance/plant-obligation-form/question/change/',
  },
  api_r_user_m_legalCompliance_plantObligationForm_calc: {
    path: 'm/legal-compliance/plant-obligation-form/calc/',
  },
  api_r_user_m_legalCompliance_plantObligationForm_help_file_download: {
    path: 'm/legal-compliance/plant-obligation-form/help-file-download/',
  },
  api_r_user_m_legalCompliance_plantObligationForm_classifiedPlants_update: {
    path: 'm/legal-compliance/plant-obligation-form/classified-plants/update/',
  },
  // Plant Information
  api_r_user_module_legalCompliance_plantInformation_get: {
    path: 'm/legal-compliance/plant-information/get/',
  },
  api_r_user_module_legalCompliance_plantInformation_downloadEvidence: {
    path: 'm/legal-compliance/plant-information/download-evidence/',
  },
  api_r_user_module_legalCompliance_plantInformation_newEvidence: {
    path: 'm/legal-compliance/plant-information/new-evidence/',
  },
  api_r_user_module_legalCompliance_plantInformation_editEvidence: {
    path: 'm/legal-compliance/plant-information/edit-evidence/',
  },
  api_r_user_module_legalCompliance_plantInformation_removeEvidence: {
    path: 'm/legal-compliance/plant-information/remove-evidence/',
  },
  // Notifications
  api_r_user_module_legalCompliance_notifications_get: {
    path: 'm/legal-compliance/notifications/get/',
  },
  api_r_user_module_legalCompliance_notifications_set: {
    path: 'm/legal-compliance/notifications/set/',
  },
  // Reports
  api_r_user_module_legalCompliance_report_pdf1: {
    path: 'm/legal-compliance/report/pdf1/',
  },
  api_r_user_module_legalCompliance_report_xls1: {
    path: 'm/legal-compliance/report/xls1/',
  },
  api_r_user_module_legalCompliance_report_xls2: {
    path: 'm/legal-compliance/report/xls2/',
  },
  api_r_user_module_legalCompliance_report_xls3: {
    path: 'm/legal-compliance/report/xls3/',
  },
  api_r_user_module_legalCompliance_report_xls4: {
    path: 'm/legal-compliance/report/xls4/',
  },
  api_r_user_module_legalCompliance_report_xls5: {
    path: 'm/legal-compliance/report/xls5/',
  },
  api_r_user_module_legalCompliance_report_xls6: {
    path: 'm/legal-compliance/report/xls6/',
  },
  api_r_user_module_legalCompliance_report_xls7: {
    path: 'm/legal-compliance/report/xls7/',
  },
  api_r_user_module_legalCompliance_report_xls8: {
    path: 'm/legal-compliance/report/xls8/',
  },
  api_r_user_module_legalCompliance_report_xls9: {
    path: 'm/legal-compliance/report/xls9/',
  },
  api_r_user_module_legalCompliance_report_doc1: {
    path: 'm/legal-compliance/report/doc1/',
  },
  api_r_user_module_legalCompliance_report_doc2: {
    path: 'm/legal-compliance/report/doc2/',
  },
  api_r_user_module_legalCompliance_report_doc3: {
    path: 'm/legal-compliance/report/doc3/',
  },
  // Milestones
  api_r_user_module_legalCompliance_milestone_getMilestones: {
    path: 'm/legal-compliance/milestone/get-milestones/',
  },
  api_r_user_module_legalCompliance_milestone_generateMilestone: {
    path: 'm/legal-compliance/milestone/generate-milestone/',
  },
  api_r_user_module_legalCompliance_milestone_remove: {
    path: 'm/legal-compliance/milestone/remove/',
  },
  api_r_user_module_legalCompliance_milestone_plant_file_get: {
    path: 'm/legal-compliance/milestone/plant/file/get/',
  },
  // Import
  api_r_user_module_legalCompliance_import_downloadWorkXls: {
    path: 'm/legal-compliance/import/download-work-xls/',
  },
  api_r_user_module_legalCompliance_import_importWorkXls: {
    path: 'm/legal-compliance/import/import-work-xls/',
  },

  // BlockChange
  api_r_user_module_legalCompliance_blockChange: {
    path: 'm/legal-compliance/block-change/',
  },
  api_r_user_module_legalCompliance_blockChange_getEvidenceList: {
    path: 'm/legal-compliance/block-change/get-evidence-list/',
  },
  // Year Calendar
  api_r_user_module_legalCompliance_yearCalendar_getInfo: {
    path: 'm/legal-compliance/year-calendar/get-info/',
  },
  api_r_user_module_legalCompliance_yearCalendar_generateFilterHexCode: {
    path: 'm/legal-compliance/year-calendar/generate-filter-hex-code/',
  },
  api_r_user_module_legalCompliance_yearCalendar_downloadXls: {
    path: 'm/legal-compliance/year-calendar/download-xls/',
  },
  // Email Queue
  api_r_user_module_legalCompliance_emailQueue_getUserList: {
    path: 'm/legal-compliance/evaluation/email-queue/list/',
  },
  // Acciona Penalty Risk
  api_r_user_module_legalCompliance_accionaPenaltyRisk_tab: {
    path: 'm/legal-compliance/acciona-penalty-risk/tab/',
  },
  api_r_user_module_legalCompliance_accionaPenaltyRisk_edit: {
    path: 'm/legal-compliance/acciona-penalty-risk/edit/',
  },
  api_r_user_module_legalCompliance_accionaPenaltyRisk_update: {
    path: 'm/legal-compliance/acciona-penalty-risk/update/',
  },
  // Copisa Penalty Risk
  api_r_user_module_legalCompliance_copisaPenaltyRisk_tab: {
    path: 'm/legal-compliance/copisa-penalty-risk/tab/',
  },
  api_r_user_module_legalCompliance_copisaPenaltyRisk_edit: {
    path: 'm/legal-compliance/copisa-penalty-risk/edit/',
  },
  api_r_user_module_legalCompliance_copisaPenaltyRisk_update: {
    path: 'm/legal-compliance/copisa-penalty-risk/update/',
  },
  // Haizea Penalty Risk
  api_r_user_module_legalCompliance_haizeaPenaltyRisk_update: {
    path: 'm/legal-compliance/haizea-penalty-risk/update/',
  },
  api_r_user_module_legalCompliance_haizeaPenaltyRisk_tab: {
    path: 'm/legal-compliance/haizea-penalty-risk/tab/',
  },
  api_r_user_module_legalCompliance_haizeaPenaltyRisk_checkDependencies: {
    path: 'm/legal-compliance/haizea-penalty-risk/check/',
  },
  // Stage gates
  api_r_user_module_legalCompliance_stageGate_list: {
    path: 'm/legal-compliance/evaluation/stage-gate/list/',
  },
  api_r_user_module_legalCompliance_stageGate_obligation_list: {
    path: 'm/legal-compliance/evaluation/stage-gate/obligation/list/',
  },
  api_r_user_module_legalCompliance_stageGate_close: {
    path: 'm/legal-compliance/evaluation/stage-gate/close/',
  },
  api_r_user_module_legalCompliance_stageGate_reopen: {
    path: 'm/legal-compliance/evaluation/stage-gate/reopen/',
  },
  api_r_user_module_legalCompliance_stageGate_toggleProject: {
    path: 'm/legal-compliance/evaluation/stage-gate/toggle-project/',
  },
  api_r_user_module_legalCompliance_stageGate_options_edit: {
    path: 'm/legal-compliance/evaluation/stage-gate/options/edit/',
  },
  api_r_user_module_legalCompliance_stageGate_file_get: {
    path: 'm/legal-compliance/evaluation/stage-gate/file/get/',
  },
  // Plant Obligation Client Elements
  api_r_user_module_legalCompliance_plantObligationClientElement_list: {
    path: 'm/legal-compliance/plantObligationClientElement/list/',
  },
  api_r_user_module_legalCompliance_plantObligationClientElement_tab: {
    path: 'm/legal-compliance/plantObligationClientElement/tab/',
  },
  api_r_user_module_legalCompliance_plantObligationClientElement_assign: {
    path: 'm/legal-compliance/plantObligationClientElement/assign/',
  },
  api_r_user_module_legalCompliance_plantObligationClientElement_unassign: {
    path: 'm/legal-compliance/plantObligationClientElement/unassign/',
  },
  api_r_user_module_legalCompliance_plantObligationClientElement_set: {
    path: 'm/legal-compliance/plantObligationClientElement/set/',
  },
  api_r_user_module_legalCompliance_plantObligationClientElement_delete: {
    path: 'm/legal-compliance/plantObligationClientElement/delete/',
  },
  api_r_user_module_legalCompliance_plantObligationClientElement_file_download:
    {
      path: 'm/legal-compliance/plantObligationClientElement/file/download/',
    },
  // Resource Manager Tab
  api_r_user_module_legalCompliance_resourceManager_tab: {
    path: 'm/legal-compliance/evaluation/resource-manager/tab/',
  },
  // Internal Obligation
  api_r_user_module_legalCompliance_internalObligation_list: {
    path: 'm/legal-compliance/internal-obligation/list/',
  },
  api_r_user_module_legalCompliance_internalObligation_add: {
    path: 'm/legal-compliance/internal-obligation/add/',
  },
  api_r_user_module_legalCompliance_internalObligation_edit: {
    path: 'm/legal-compliance/internal-obligation/edit/',
  },
  api_r_user_module_legalCompliance_internalObligation_delete: {
    path: 'm/legal-compliance/internal-obligation/delete/',
  },
  api_r_user_module_legalCompliance_infoRequest_list: {
    path: 'm/legal-compliance/info-request/list/',
  },
  api_r_user_module_legalCompliance_infoRequest_delete: {
    path: 'm/legal-compliance/info-request/delete/',
  },
};
